const MAP_LINK =
  'https://www.google.com/maps/place/104+Bristol+Hill+Rd,+Bristol,+NH+03222/@43.5978281,-71.7552678,17z/data=!3m1!4b1!4m5!3m4!1s0x4cb351880804ebed:0x29f63faa9d6f3455!8m2!3d43.5978281!4d-71.7530791';

const Contact = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Get in touch</span>
          <h2>Plan your stay at Upward Bound.</h2>
          <p>Tell us about your group and your dates. As a nonprofit, we prioritize youth groups,
            then churches and charitable organizations, with families welcomed as space allows.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <h3>Upward Bound Retreat &amp; Camp</h3>
            <div className="contact-rows">
              <div className="contact-row">
                <div className="lbl">Hosts</div>
                <div className="val">Jason &amp; Megan Giordano</div>
              </div>
              <div className="contact-row">
                <div className="lbl">Mailing Address</div>
                <div className="val">
                  P.O. Box 529<br />
                  Oak Bluffs, MA 02557
                </div>
              </div>
              <div className="contact-row">
                <div className="lbl">Email</div>
                <div className="val">
                  <a href="mailto:contact@upwardboundretreat.com">contact@upwardboundretreat.com</a>
                </div>
              </div>
              <div className="contact-row">
                <div className="lbl">Phone</div>
                <div className="val">(978) 852-5555<br />(508) 627-1737</div>
              </div>
            </div>
          </div>

          <div className="contact-media">
            <img src="/images/interior/contact.jpg" alt="The cabin along the road in autumn" />
            <a className="map" href={MAP_LINK} target="_blank" rel="noreferrer">
              <img src="/images/interior/upward_map.png" alt="Map to the cabin in Bristol, New Hampshire" />
              <span className="map-cap">104 Bristol Hill Road · Bristol, NH 03222 — open in Maps ↗</span>
            </a>
            <p className="directions">
              Located just 1 hour and 45 minutes north on Route 93 from Boston;
              35 minutes north of Concord, NH.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
